import { customElement, bindable, bindingMode, autoinject } from 'aurelia-framework';
import 'jquery';
import 'Bloodhound';
import 'typeahead';

let nextId = 1;

@autoinject
export class TypeAhead {
    @bindable prepareQuery: Function;
    @bindable onSelect: Function;
    @bindable hinttext: string;
    @bindable labeltext: string;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) initialValue: any;
    private inputId = "ta-" + nextId++;
    private suggestionEngine: Bloodhound<any>;
    private typeahead: JQuery;

    constructor(private element: Element) {
        this.suggestionEngine = new Bloodhound<any>({
            //datumTokenizer: function (datum) {
            //    return Bloodhound.tokenizers.whitespace(datum.legalName);
            //},
            datumTokenizer: Bloodhound.tokenizers.whitespace,
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            //local: [{ "value": "dog" }, { "value": "cat" }, { "value": "toad" }, { "value": "fish" }]
            //local: ["dog", "cat", "bird", "fish"]
            remote: {
                url: 'http://set-by-interceptor',
                prepare: (query, settings) => this.prepareQuery(query, settings),
                rateLimitWait: 500
            }
        });
        this.suggestionEngine.initialize();
    }

    provideSuggestion(data) {
        // `data` : `suggest` property of object passed at `Bloodhound`
        var html = ""
        html += "<table>";

        html += `<tr><td colspan='2'><b>${data.legalName}</b></td></tr>`;
        if (data.dbaName) {
            html += `<tr><td colspan='2'>DBA: ${data.dbaName}</td></tr>`;
        }
        if (data.alternateName) {
            html += `<tr><td colspan='2'>Alternate: ${data.alternateName}</td></tr>`;
        }
        html += `<tr><td>NGTVID: ${data.ngtvid}</td><td>&nbsp;&nbsp;&nbsp;DOT #: ${data.dotNumber}</td></tr>`;
        if (data.scacCode) {
            html += `<tr><td colspan='2'>SCAC: ${data.scacCode}</td></tr>`;
        }
        if (data.dedicatedScacCodes) {
            html += `<tr><td colspan='2'>Additional SCAC: ${data.dedicatedScacCodes}</td></tr>`;
        }
        if (data.carrierPointId) {
            html += `<tr><td colspan='2'>Carrier Point ID: ${data.carrierPointId}</td></tr>`;
        }
        html += "</table>";
        return html;
    }

    attached() {
        let options: Twitter.Typeahead.Options = { minLength: 2, highlight: true };
        let dataset: Twitter.Typeahead.Dataset<any> = {
            source: this.suggestionEngine,
            async: true,
            limit: 10, // needs to be same as whatever is fetched by api
            display: "legalName",
            templates: {
                notFound: [
                    "<div>no results</div>"
                ].join("\n"),
                suggestion: this.provideSuggestion
            }
        };

        let ele = jQuery(this.element).find("input");
        this.typeahead = ele.typeahead(options, [dataset]);
        //this.typeahead = ele.typeahead(null, <Twitter.Typeahead.Dataset<any>>{
        //    //display: 'value',
        //    async: true,
        //    source: this.suggestionEngine.ttAdapter(),
        //});

        if (this.initialValue)
            this.setValue(this.initialValue);

        this.typeahead.on('typeahead:select', (ev, suggestion) => {
            this.onSelect({ suggestion: suggestion });
            this.setValue("");
        });
    }

    initialValueChanged() {
        this.setValue(this.initialValue)
    }

    private setValue(valueObj) {
        if (!this.typeahead) return;

        let value = valueObj && valueObj.name ? valueObj.name : "";

        var typeaheadInput = this.typeahead.data('ttTypeahead').input;
        // Typeahead doesn't seem to fully sync objects (https://github.com/valor-software/ng2-bootstrap/issues/749)
        // so we just set the display correctly. This relies on the assumption that the underlying value for this field
        // is being stored in the class using typeahead, and updated via the onSelect below.  In effect, if the user doesn't
        // change anything the UI will appear to be right and the backing field will be unchanged, and if they do change
        // something then the normal process for onSelect() will apply and return a full object.
        typeaheadInput.setQuery(value);
        typeaheadInput.resetInputValue();
    }
}